export default {"src":"/_next/static/media/MAS.0e1009a8.svg","height":18,"width":18};